import { render, staticRenderFns } from "./DialogAbsensi.vue?vue&type=template&id=50877b23&scoped=true"
import script from "./DialogAbsensi.vue?vue&type=script&lang=js"
export * from "./DialogAbsensi.vue?vue&type=script&lang=js"
import style0 from "./DialogAbsensi.vue?vue&type=style&index=0&id=50877b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50877b23",
  null
  
)

export default component.exports